var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChatIcon = function SvgChatIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H39C41.7614 0 44 2.23858 44 5V27C44 29.7614 41.7614 32 39 32H36V38C36 38.7876 35.5378 39.5018 34.8193 39.8245C34.1008 40.1471 33.2599 40.0181 32.6713 39.4948L24.2396 32H5C2.23858 32 0 29.7614 0 27V5ZM5 4C4.44772 4 4 4.44772 4 5V27C4 27.5523 4.44772 28 5 28H25C25.4898 28 25.9626 28.1798 26.3287 28.5052L32 33.5463V30C32 28.8954 32.8954 28 34 28H39C39.5523 28 40 27.5523 40 27V5C40 4.44771 39.5523 4 39 4H5Z",
    fill: "#abb5bb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 19C14.6569 19 16 17.6569 16 16C16 14.3431 14.6569 13 13 13C11.3431 13 10 14.3431 10 16C10 17.6569 11.3431 19 13 19Z",
    fill: "#abb5bb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 19C23.6569 19 25 17.6569 25 16C25 14.3431 23.6569 13 22 13C20.3431 13 19 14.3431 19 16C19 17.6569 20.3431 19 22 19Z",
    fill: "#abb5bb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 19C32.6569 19 34 17.6569 34 16C34 14.3431 32.6569 13 31 13C29.3431 13 28 14.3431 28 16C28 17.6569 29.3431 19 31 19Z",
    fill: "#abb5bb"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat-icon.629dcd28.svg";
export { ForwardRef as ReactComponent };